// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"FuncionTable_spinnerContainer__zB0Mb","botonAdd":"FuncionTable_botonAdd__cWCET"};